import { ModalProvider } from './../providers/modal/modal';
import { Realtime } from './../providers/realtime';
import { HomePage } from './../pages/home/home';
import { LoginPage } from './../pages/login/login';
import { AppFacade } from './../facade/app.facade';
import { Component, OnInit } from '@angular/core';
import { Platform } from 'ionic-angular';

import { Dock } from "../models/Dock";

@Component({
  templateUrl: 'app.html'
})
export class TielbekeApp implements OnInit {

  public rootPage: any = HomePage;
  public docks$ = this.facade.docks$;
  public authenticated: boolean = false;
  public searchValue: string;
  public showDrawer: any;

  constructor(
    public facade: AppFacade,
    private realtime: Realtime,
    private modalProvider: ModalProvider,
    public platform: Platform,
  ) {

    this.facade.auth$.subscribe(res => {
      if(!res.authenticated) {
        this.authenticated = false
        this.rootPage = LoginPage
        this.realtime.disconnect();
      } else {
        this.authenticated = true
        this.rootPage = HomePage
        this.realtime.connect();
      }
    })
  }

  getItems(ev: any) {
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    this.docks$ = this.facade.docks$
    if (val && val.trim() != '') {
      this.docks$ = this.docks$.map((item:any) => {
        return item.filter(e => {
          return e.title.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      })
    }
  }

  toggleDock(event: {id: Number, active: Number}) {
     this.facade.toggleDockStatus(event.id, event.active)
  }

  showModal(dock: Dock) {
    this.modalProvider.open(dock);
  }

  logout() {
    this.facade.logout()
  }

  ngOnInit() {
    if(this.platform.is('core')) {
      this.showDrawer = false;
    } else {
      this.showDrawer = 'lg'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts